import React from 'react';
import propTypes from 'prop-types';

import Layout, {
  LayoutHeader,
  LayoutBody,
  LayoutFooter
} from '../Layout';

import './Poi.css';

import {
  isHotel,
  isUserHotel,
  isUserTravel,
  isPickup,
  isDropoff,
  isStore,
  isAttraction,
  getStayTime
} from '../../../../../helpers/poi';
import * as navigator from '../../../../../native/navigator';
import { sendStatsEvent } from '../../../../../components/statistics/index';
import { isShare } from '../../../from';


const labelMap = {
  startPoint: '出发点', // isPrev
  pickupPoint: '取车', // isStore
  'dropoffPoint': '还车' // isStore
};


PoiContainer.propTypes = {
  // 为了方便UI。poi对象扩展了isPrev属性，也可以是字符串：add-poi, add-hotel
  uiPoi: propTypes.oneOfType([
    propTypes.object,
    propTypes.oneOf(['add-poi', 'add-hotel'])
  ]).isRequired,
  day: propTypes.number.isRequired,
  trip: propTypes.object.isRequired
};

export default function PoiContainer(props) {
  let {uiPoi, trip, day} = props;
  let label;

  if (uiPoi.isPrev) day--;

  if (uiPoi === 'add-poi') {
    return (
      <PoiAdd
        trip={trip}
        day={day}
        uiPoi={uiPoi}
        type='other' />
    );
  } else if (uiPoi === 'add-hotel') {
    return (
      <PoiAdd
        trip={trip}
        day={day}
        uiPoi={uiPoi}
        type='hotel' />
    );
  } else if (uiPoi.isPrev && !isHotel(uiPoi)) {
    label = 'startPoint';

    return (
      <PoiAdd
        trip={trip}
        day={day}
        uiPoi={uiPoi}
        type='hotel'
        label={label} />
    );
  } else {
    if (uiPoi.isPrev) {
      label = 'startPoint';
    }

    if (isPickup(uiPoi)) {
      label = 'pickupPoint';
    }

    if (isDropoff(uiPoi)) {
      label = 'dropoffPoint';
    }

    return (<Poi poi={uiPoi} trip={trip} day={day} label={label} />);
  }
}



Poi.propTypes = {
  trip: propTypes.object.isRequired,
  day: propTypes.number.isRequired,
  poi: propTypes.object.isRequired,
  label: propTypes.oneOf(['startPoint', 'pickupPoint', 'dropoffPoint'])
};

function Poi(props) {
  let {poi, label, trip, day} = props;
  let img = poi.info.pic.small_s;
  let labelText = labelMap[label];
  let stayTime = isAttraction(poi) || isUserTravel(poi)? getStayTime(poi) : '';
  let layoutClass = isUserHotel(poi) ? 'poi user-hotel' : 'poi';
  return (
    <Layout className={layoutClass} onClick={() => {
      if (isUserHotel(poi)) {
        navigator.push('/m/v2/?m=render2&page=trip-modify-customhotel', {
          poi_uid: poi.poi_uid,
          trip_id: trip.trip_id,
          day: day
        });
      }else if (isUserTravel(poi)) {
        navigator.push('/m/v2/?m=render2&page=custompoi', {
          poi_uid: poi.poi_uid,
          trip_id: trip.trip_id
        });
      }else if (isHotel(poi)) {
        navigator.push('/m/v2/?m=render2&page=trip-modify-hotel', {
          poi_uid: poi.poi_uid,
          trip_id: trip.trip_id,
          day: day
        });
      } else if (isStore(poi)) {
        sendStatsEvent('trip_Carrentalstore_click');
        navigator.push(poi.info.store_link);
      } else {
        sendStatsEvent('trip_poidetails_click_3');
        navigator.push('/m/v2/?m=render2&page=poi', {
          poi_uid: poi.poi_uid
        });
      }
    }}>
      <LayoutHeader className='header time-line'>
        {
          isHotel(poi)
            ? (
              <div className='icon-container'>
                <div><i className='icon icon-hotel-circle' /></div>
              </div>
            )
            : (
              <div className='image-container'>
                <div className='image' style={{
                  backgroundImage: `url(${img})`
                }} />
              </div>
            )
        }
      </LayoutHeader>

      <LayoutBody className='body'>
        <h3>
          <span>{poi.info.cn_name}</span>
          {labelText ? (<em className="label">{labelText}</em>) : null}
        </h3>
        <p>{poi.info.en_name}</p>
        {stayTime ? (<p>建议游玩{stayTime}小时</p>) : null}
      </LayoutBody>

      {poi.isPrev && isHotel(poi) ? (
        <LayoutFooter className='footer'>
          <span>昨天酒店</span>
        </LayoutFooter>
      ) : null}
    </Layout>
  );
}




PoiAdd.titles = [
  '前一天还没有安排酒店',
  '今天还没安排游玩景点',
  '今天还没安排酒店'
];

PoiAdd.iconMap = {
  hotel: 'icon-hotel-circle',
  other: 'icon-attraction'
};


PoiAdd.propTypes = {
  trip: propTypes.object.isRequired,
  day: propTypes.number.isRequired,
  uiPoi: propTypes.oneOfType([
    propTypes.object,
    propTypes.oneOf(['add-poi', 'add-hotel'])
  ]).isRequired,
  // poi类型
  type: propTypes.oneOf(['hotel', 'other']).isRequired,
  label: propTypes.oneOf(['startPoint'])
};

function PoiAdd(props) {
  let {type, uiPoi, label, day, trip} = props;
  let icon = PoiAdd.iconMap[type];
  let labelText = labelMap[label];
  let title, desc;

  if (type === 'other') {
    title = PoiAdd.titles[1];
  } else {
    if (uiPoi.isPrev) {
      title = PoiAdd.titles[0];
    } else {
      title = PoiAdd.titles[2];
    }
  }

  if (uiPoi.isPrev) {
    desc = '未设置酒店，按前一天最后的景点为出发点';
  }

  return (
    <Layout className='poi-add' onClick={() => {
      if(isShare()) return;
      if (uiPoi === 'add-poi') {
        sendStatsEvent('trip_addpoi_click_2');
        navigator.push('/m/v2/?m=render2&page=trip-modify-pois', {
          day: day,
          trip_id: trip.trip_id
        });
      } else if (uiPoi === 'add-hotel') {
        sendStatsEvent('trip_addhotel_click_1');
        navigator.push('/m/v2/?m=render2&page=trip-modify-hotels-search', {
          day: day,
          trip_id: trip.trip_id
        });
      } else {
        // 前天酒店
        sendStatsEvent('trip_addhotel_click_2');
        navigator.push('/m/v2/?m=render2&page=trip-modify-hotels-search', {
          day: day,
          trip_id: trip.trip_id
        });
      }
    }}>
      <LayoutHeader className='header time-line'>
        <div className='icon-container'>
          <div><i className={`icon ${icon}`} /></div>
        </div>
      </LayoutHeader>
      <LayoutBody className='body'>
        <h3>
          <span>{title}</span>
          {labelText ? (<em className="label">{labelText}</em>) : null}
        </h3>
        <p>{desc}</p>
      </LayoutBody>
      <LayoutFooter className='footer'>
        <i className='icon icon-add' />
      </LayoutFooter>
    </Layout>
  );
}




// WEBPACK FOOTER //
// ./src/pages/trip/Trip/DayTrip/PoiList/Poi.js